
export class ServiceRequestCommentReplyModel{
    ServiceRequestNotesReplyID : number;
    ServiceRequestNotesID  : number;
    Notes : string;
    Status : string;
    PoestedBy : number;
    FromApplication: string;
}




// WEBPACK FOOTER //
// ./src/app/models/ServiceRequestCommentReplyModel.ts